import {
    AdsenseCell,
    ChangePercentage,
    IndexCell,
    RankCell,
    ReferringCategoryCell,
    TrafficShare,
    WebsiteTooltipTopCell,
    IndustryTrafficSource,
    GroupTrafficShare,
    DefaultCell,
} from "app/components/React/Table/cells";
import { DefaultCellHeader, HeaderCellBlank } from "app/components/React/Table/headerCells";

import { TrafficShareWithTooltip } from "pro-features/components/TrafficShare/src/TrafficShareWithTooltip";
import { i18nFilter } from "../../../../../filters/i18nFilter";

const DEFAULT_SORT_FIELD = "Share";
const DEFAULT_SORT_FIELD_MOBILE_COMPARE = "TotalShare";
const DEFAULT_SORT_DIRECTION = "desc";
const i18n = i18nFilter();
export const IncomingTrafficSingleTableSettings = {
    defaultSortField: DEFAULT_SORT_FIELD,
    defaultSortDirection: DEFAULT_SORT_DIRECTION,
    searchFieldName: "domain",
    getColumns: (
        sortedColumn = { field: DEFAULT_SORT_FIELD, sortDirection: DEFAULT_SORT_DIRECTION },
        isDaily = false,
        handleOpenQualificationSideBar = undefined,
    ) => {
        const columns: any = [
            {
                fixed: true,
                cellComponent: IndexCell,
                headerComponent: HeaderCellBlank,
                disableHeaderCellHover: true,
                sortable: false,
                isResizable: false,
                width: 65,
            },
            {
                minWidth: 214,
                isResizable: true,
                sortable: true,
                field: "Domain",
                showTotalCount: true,
                displayName: i18n("analysis.source.referrals.table.columns.domain.title"),
                tooltip: i18n("analysis.source.referrals.table.columns.domain.title.tooltip"),
                cellComponent: (props) => {
                    return (
                        <WebsiteTooltipTopCell
                            {...props}
                            handleOpenQualificationSideBar={handleOpenQualificationSideBar}
                        />
                    );
                },
            },
            {
                minWidth: 244,
                isResizable: true,
                sortable: true,
                field: "Category",
                displayName: i18n("analysis.source.referrals.table.columns.category.title"),
                tooltip: i18n("analysis.source.referrals.table.columns.category.title.tooltip"),
                cellComponent: ReferringCategoryCell,
            },
            {
                minWidth: 100,
                isResizable: true,
                sortable: true,
                field: "Rank",
                displayName: i18n("analysis.source.referrals.table.columns.rank.title"),
                tooltip: i18n("analysis.source.referrals.table.columns.rank.title.tooltip"),
                cellComponent: RankCell,
            },
            {
                minWidth: 120,
                sortable: true,
                isResizable: true,
                field: "Share",
                displayName: i18n("analysis.source.referrals.table.columns.share.title"),
                tooltip: i18n("analysis.source.referrals.table.columns.share.title.tooltip"),
                cellComponent: TrafficShare,
            },
            {
                minWidth: 104,
                isResizable: true,
                sortable: true,
                field: "Change",
                displayName: i18n("analysis.source.search.all.table.columns.change.title"),
                tooltip: i18n("arena.visits.table.tooltip.change"),
                cellComponent: ChangePercentage,
                visible: !isDaily,
            },
            {
                width: 95,
                sortable: true,
                field: "HasAdsense",
                displayName: i18n("analysis.all.table.columns.googleads.title"),
                tooltip: i18n("analysis.all.table.columns.googleads.title.tooltip"),
                cellComponent: AdsenseCell,
            },
        ];
        return columns.map((col: any) => {
            const isSorted = sortedColumn && col.field === sortedColumn.field;
            return {
                ...col,
                visible: col.visible === false ? false : true,
                headerComponent: col.headerComponent || DefaultCellHeader,
                isSorted,
                sortDirection: isSorted ? sortedColumn.sortDirection : DEFAULT_SORT_DIRECTION,
            };
        });
    },
};

export const IncomingTrafficCompareTableSettings = {
    defaultSortField: DEFAULT_SORT_FIELD_MOBILE_COMPARE,
    defaultSortDirection: DEFAULT_SORT_DIRECTION,
    searchFieldName: "domain",
    getColumns: (
        sortedColumn = {
            field: DEFAULT_SORT_FIELD_MOBILE_COMPARE,
            sortDirection: DEFAULT_SORT_DIRECTION,
        },
        handleOpenQualificationSideBar = undefined,
    ) => {
        const columns: any = [
            {
                fixed: true,
                cellComponent: IndexCell,
                headerComponent: HeaderCellBlank,
                sortable: false,
                isResizable: false,
                width: 65,
            },
            {
                width: 250,
                sortable: true,
                field: "Domain",
                showTotalCount: true,
                displayName: i18n("analysis.source.referrals.table.columns.domain.title"),
                tooltip: i18n("analysis.source.referrals.table.columns.domain.title.tooltip"),
                cellComponent: (props) => {
                    return (
                        <WebsiteTooltipTopCell
                            {...props}
                            handleOpenQualificationSideBar={handleOpenQualificationSideBar}
                        />
                    );
                },
            },
            {
                width: 200,
                sortable: true,
                field: "Category",
                displayName: i18n("analysis.source.referrals.table.columns.category.title"),
                tooltip: i18n("analysis.source.referrals.table.columns.category.title.tooltip"),
                cellComponent: ReferringCategoryCell,
            },
            {
                width: 150,
                sortable: true,
                field: "TotalShare",
                displayName: i18n("analysis.source.search.all.table.columns.totalShareCompare.title"),
                tooltip: i18n("analysis.source.search.all.table.columns.totalShareCompare.general.title.tooltip"),
                cellComponent: TrafficShare,
            },
            {
                field: "trafficDistribution",
                displayName: i18n("analysis.source.search.all.table.columns.shareCompare.title"),
                tooltip: i18n("analysis.source.search.all.table.columns.shareCompare.title.tooltip"),
                cellComponent: ({ value, tooltipTitle }) => {
                    return (
                        <TrafficShareWithTooltip
                            data={value}
                            title={tooltipTitle}
                        />
                    );
                },
                tooltipTitle: i18n("incomingtraffic.competitivetrafficshare.tooltip"),
            },
        ];
        return columns.map((col: any) => {
            const isSorted = sortedColumn && col.field === sortedColumn.field;
            return {
                ...col,
                visible: true,
                headerComponent: col.headerComponent || DefaultCellHeader,
                isSorted,
                sortDirection: isSorted ? sortedColumn.sortDirection : DEFAULT_SORT_DIRECTION,
            };
        });
    },
};

export const IncomingTrafficSingleDesktopTableSettings = {
    defaultSortField: DEFAULT_SORT_FIELD,
    defaultSortDirection: DEFAULT_SORT_DIRECTION,
    searchFieldName: "domain",
    getColumns: (
        sortedColumn = { field: DEFAULT_SORT_FIELD, sortDirection: DEFAULT_SORT_DIRECTION },
        isDaily = false,
        handleOpenQualificationSideBar = undefined,
    ) => {
        const columns: any = [
            {
                fixed: true,
                cellComponent: IndexCell,
                headerComponent: DefaultCellHeader,
                disableHeaderCellHover: true,
                sortable: false,
                width: 45,
                visible: true,
            },
            {
                fixed: true,
                field: "Domain",
                cellComponent: (props) => {
                    return (
                        <IndustryTrafficSource
                            {...props}
                            handleOpenQualificationSideBar={handleOpenQualificationSideBar}
                        />
                    );
                },
                displayName: i18n("analysis.source.referrals.table.columns.trafficsource.title"),
                tooltip: i18n("analysis.source.referrals.table.columns.trafficsource.title.tooltip"),
                sortable: true,
                showTotalCount: true,
                width: 220,
                groupable: true,
            },
            {
                field: "Share",
                displayName: i18nFilter()("analysis.source.referrals.table.columns.share.title"),
                tooltip: i18nFilter()("analysis.source.referrals.table.columns.grouptrafficshare.title.tooltip"),
                type: "double",
                sortable: true,
                isSorted: false,
                cellComponent: TrafficShare,
                headerComponent: DefaultCellHeader,
                sortDirection: "desc",
                width: 130,
                visible: true,
            },
            {
                minWidth: 104,
                isResizable: true,
                sortable: true,
                field: "Change",
                displayName: i18n("analysis.source.referrals.table.columns.change.title"),
                tooltip: i18n("analysis.source.referrals.table.columns.change.title.tooltip"),
                cellComponent: ChangePercentage,
                visible: !isDaily,
            },
            {
                field: "SourceType",
                cellComponent: DefaultCell,
                displayName: i18n("analysis.source.referrals.table.columns.sourcetype.title"),
                tooltip: i18n("analysis.source.referrals.table.columns.sourcetype.title.tooltip"),
                sortable: true,
                width: 160,
                visible: true,
            },
            {
                minWidth: 100,
                isResizable: true,
                sortable: true,
                field: "Rank",
                displayName: i18n("analysis.source.referrals.table.columns.rank.title"),
                tooltip: i18n("analysis.source.referrals.table.columns.rank.title.tooltip"),
                cellComponent: RankCell,
            },
            {
                field: "Category",
                type: "string",
                format: "prettifyCategoryText",
                cellComponent: DefaultCell,
                displayName: i18n("analysis.source.referrals.table.columns.cat.title"),
                tooltip: i18n("analysis.source.referrals.table.columns.cat.title.tooltip"),
                sortable: true,
                width: 220,
                visible: true,
            },
        ];
        return columns.map((col: any) => {
            const isSorted = sortedColumn && col.field === sortedColumn.field;
            return {
                ...col,
                visible: true,
                headerComponent: col.headerComponent || DefaultCellHeader,
                isSorted,
                sortDirection: isSorted ? sortedColumn.sortDirection : DEFAULT_SORT_DIRECTION,
            };
        });
    },
};

export const IncomingTrafficCompareDesktopTableSettings = {
    defaultSortField: DEFAULT_SORT_FIELD,
    defaultSortDirection: DEFAULT_SORT_DIRECTION,
    searchFieldName: "domain",
    getColumns: (
        sortedColumn = { field: DEFAULT_SORT_FIELD, sortDirection: DEFAULT_SORT_DIRECTION },
        handleOpenQualificationSideBar = undefined,
    ) => {
        const columns: any = [
            {
                fixed: true,
                cellComponent: IndexCell,
                headerComponent: DefaultCellHeader,
                disableHeaderCellHover: true,
                sortable: false,
                width: 45,
                visible: true,
            },
            {
                fixed: true,
                field: "Domain",
                cellComponent: (props) => {
                    return (
                        <IndustryTrafficSource
                            {...props}
                            handleOpenQualificationSideBar={handleOpenQualificationSideBar}
                        />
                    );
                },
                displayName: i18n("analysis.source.referrals.table.columns.trafficsource.title"),
                tooltip: i18n("analysis.source.referrals.table.columns.trafficsource.title.tooltip"),
                sortable: true,
                showTotalCount: true,
                width: 220,
                groupable: true,
            },
            {
                field: "SourceType",
                cellComponent: DefaultCell,
                displayName: i18n("analysis.source.referrals.table.columns.sourcetype.title"),
                tooltip: i18n("analysis.source.referrals.table.columns.sourcetype.title.tooltip"),
                sortable: true,
                width: 160,
                visible: true,
            },
            {
                field: "Share",
                displayName: i18nFilter()("analysis.source.referrals.table.columns.grouptrafficshare.title"),
                tooltip: i18nFilter()("analysis.source.referrals.table.columns.grouptrafficshare.title.tooltip"),
                type: "double",
                sortable: true,
                isSorted: false,
                cellComponent: TrafficShare,
                headerComponent: DefaultCellHeader,
                sortDirection: "desc",
                width: 160,
                visible: true,
            },
            {
                field: "SiteOrigins",
                displayName: i18nFilter()("analysis.source.referrals.table.columns.groupsharesplit.title"),
                // tooltip: i18nFilter()("analysis.audience.geo.table.columns.share.title.tooltip"),
                tooltip: i18nFilter()("analysis.source.referrals.table.columns.groupsharesplit.title.tooltip"),
                type: "double[]",
                format: "percentagesign",
                sortable: false,
                isSorted: false,
                groupable: false,
                headerComponent: DefaultCellHeader,
                cellComponent: GroupTrafficShare,
                totalCount: false,
                width: 220,
                visible: true,
                ppt: {
                    // Indicates that we want to split this column into sub-columns
                    // where each sub-column will be a table entity (table item - a website/app/category.
                    // such as ynet.co.il, whatsapp, all industries etc.)
                    splitColumnToEntities: true,

                    // override the table column format when rendered in ppt
                    overrideFormat: "smallNumbersPercentage:1",

                    // Override default value when no value is present in a table row
                    defaultValue: "0",
                },
            },
            {
                field: "Category",
                type: "string",
                format: "prettifyCategoryText",
                cellComponent: DefaultCell,
                displayName: i18n("analysis.source.referrals.table.columns.cat.title"),
                tooltip: i18n("analysis.source.referrals.table.columns.cat.title.tooltip"),
                sortable: true,
                width: 210,
                visible: true,
            },
        ];
        return columns.map((col: any) => {
            const isSorted = sortedColumn && col.field === sortedColumn.field;
            return {
                ...col,
                visible: true,
                headerComponent: col.headerComponent || DefaultCellHeader,
                isSorted,
                sortDirection: isSorted ? sortedColumn.sortDirection : DEFAULT_SORT_DIRECTION,
            };
        });
    },
};
